import {
  Box,
  Center,
  Pagination,
  ScrollArea,
  Stack,
  Table,
  Text,
  Title,
} from "@mantine/core";
import { useEffect, useState } from "react";
import { useSessionStore } from "stores/userSessionStore";

import { safeApiCall } from "api/common.service";
import { getBackOrders } from "api/order.service";

const PAGE_SIZE = 30;

const BackOrderPage: React.FC = () => {
  const backOrders = useSessionStore((state) => state.backOrders);
  const [activePage, setPage] = useState(1);

  const paginatedData = backOrders.slice(
    (activePage - 1) * PAGE_SIZE,
    activePage * PAGE_SIZE
  );

  const rows = paginatedData.map((order) => (
    <Table.Tr key={order.id}>
      <Table.Td>{order.productDesc}</Table.Td>
      <Table.Td>{order.quantity}</Table.Td>
    </Table.Tr>
  ));

  useEffect(() => {
    const { backOrders } = useSessionStore.getState();
    // Fetch back orders when the component mounts
    (async () => {
      const resp = await safeApiCall(getBackOrders());
      useSessionStore.getState().setBackOrders(resp?.data || []);
    })();
  }, []);

  return (
    <Box>
      <Stack>
        <Title order={2}>My Back Orders</Title>
        <Text size="sm" c="dimmed">
          Showing 30 items per page
        </Text>

        <ScrollArea>
          <Table
            striped
            highlightOnHover
            withTableBorder
            style={{ minWidth: 740 }}
          >
            <Table.Thead>
              <Table.Tr>
                <Table.Th>Description</Table.Th>
                <Table.Th>Quantity</Table.Th>
              </Table.Tr>
            </Table.Thead>
            <Table.Tbody>
              {rows.length > 0 ? (
                rows
              ) : (
                <Table.Tr>
                  <Table.Td colSpan={7}>No backorders found.</Table.Td>
                </Table.Tr>
              )}
            </Table.Tbody>
            <Table.Tfoot>
              <Table.Tr>
                <Table.Td colSpan={7}>
                  <Center>
                    {/* Right: Pagination */}
                    <Pagination
                      total={Math.ceil(backOrders.length / PAGE_SIZE)}
                      value={activePage}
                      onChange={setPage}
                      mt="md"
                    />
                  </Center>
                </Table.Td>
              </Table.Tr>
            </Table.Tfoot>
          </Table>
        </ScrollArea>
      </Stack>
    </Box>
  );
};

export default BackOrderPage;
